module.exports = __webpack_public_path__ + "images/academy-wizard-hero.4616cbd88f166e1469886d6313806925.webp";